import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Awakening() {
  const { t } = useTranslation();

  return (
    <section className="Awakening fade">
      <h2>{t("awakening.title")}</h2>
      <p>{t("awakening.text")}</p>

      <ul className="awakening-cards">
        <Link to={"/awakening"}>
          <li className="awakening-card yellow">{t("awakening.card1")}</li>
        </Link>
        <Link to={"/awakening"}>
          <li className="awakening-card green">{t("awakening.card2")}</li>
        </Link>
        <Link to={"/awakening"}>
          <li className="awakening-card red">{t("awakening.card3")}</li>
        </Link>
        <Link to={"/awakening"}>
          <li className="awakening-card blue">{t("awakening.card4")}</li>
        </Link>
      </ul>

      <Link className="button awakening-button" to="/awakening">
        {t("awakening.button")}
      </Link>
    </section>
  );
}
